import { render, staticRenderFns } from "./CompForm.vue?vue&type=template&id=d64b2c3e&scoped=true&"
import script from "./CompForm.vue?vue&type=script&lang=js&"
export * from "./CompForm.vue?vue&type=script&lang=js&"
import style0 from "./CompForm.vue?vue&type=style&index=0&id=d64b2c3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64b2c3e",
  null
  
)

export default component.exports